export default {
  path: '/wizard',
  name: 'wizard',
  meta: {},
  component: () => import(/* webpackChunkName: "wizard" */ './views/Wizard.vue'),
  children: [
    {
      path: 'transfer-balance-cap',
      name: 'wizard-tbc',
      meta: {
      },
      component: () => import(/* webpackChunkName: "wizard-tbc" */ './views/tbc/WizardTBC.vue'),
    },
  ],
};
